import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import { useCampaignContext } from "../context/CampaignContext";

async function getTargetsToken(
  workspaceId: string,
  campaignId: string,
): Promise<string> {
  return (
    await get(
      `workspaces/${workspaceId}/campaigns/${campaignId}/audience-token`,
    )
  ).token;
}

export default function useAudienceToken() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { id: campaignId } = useCampaignContext();

  const { campaignsKeys } = getQueryKeys(workspaceId);

  const { data: audienceToken } = useQuery({
    queryKey: campaignsKeys.audienceToken(campaignId),
    queryFn: () => getTargetsToken(workspaceId, campaignId),
  });

  return { audienceToken };
}
